export default [
    {
        path: "/autowrite/account/list",
        name: "autowrite-account-list",
        component: () => import("@/views/autowrite/account/list.vue"),
    },
    {
        path: "/autowrite/task/list",
        name: "autowrite-task-list",
        component: () => import("@/views/autowrite/task/list.vue"),
    },
    {
        path: "/autowrite/task/new",
        name: "autowrite-task-new",
        component: () => import("@/views/autowrite/task/new.vue"),
    },
    {
        path: "/autowrite/stat/dashboard",
        name: "autowrite-stat-dashboard",
        component: () => import("@/views/autowrite/stat/dashboard.vue"),
    },
    {
        path: "/autowrite/stat/task",
        name: "autowrite-stat-task",
        component: () => import("@/views/autowrite/stat/task.vue"),
    },
]